import { useParams } from "react-router-dom";
import ClientViewAuditTimeline from "../../components/clientPortal/ClientViewAuditTimeline";

export default function ClientSettingsAuditPage() {
  const { clientViewId } = useParams();

  return (
    <>
      <section className="panel-card cp-settings-section-header">
        <h3>Audit log</h3>
        <p className="muted">
          Invites, role changes, organization assignments, and other administrative actions for this
          view.
        </p>
      </section>
      <ClientViewAuditTimeline clientViewId={clientViewId} />
    </>
  );
}
